import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  isLoadedRosterHistorySelector,
  isLoadingRosterHistorySelector,
  rosterHistorySelector,
  rosterScopeDaysSelector
} from '../../../selectors/rosterHistory';
import RosterHistoryActions from '../../../actions/rosterHistoryActions';
import apiService from '../../../services/apiService';

export const useRosterHistory = (groupId: number) => {
  const dispatch = useDispatch();
  const isLoading = useSelector(isLoadingRosterHistorySelector);
  const history = useSelector(rosterHistorySelector);
  const isLoaded = useSelector(isLoadedRosterHistorySelector);
  const scopeDays = useSelector(rosterScopeDaysSelector);

  useEffect(() => {
    if (!isLoading && !isLoaded) {
      dispatch(RosterHistoryActions.showLoadingSpinner(true));
      apiService.getGroupHistory(groupId, (err: any, result?: any) => {
        if (err || !result) {
          return;
        }

        dispatch(RosterHistoryActions.showLoadingSpinner(false));
        dispatch(RosterHistoryActions.setRosterHistory(result));
      });
    }
  }, [groupId]);

  return {
    history,
    isLoading,
    scopeDays,
    isLoaded
  };
};
